const mapLegacyPolicy = ({
  title,
  subTitle = "",
  policyTitle = "",
  policies = [],
  guaranteeTitle = "",
  guarantee = [],
  note = "",
  noteDetails = "",
  paymentTitle = "",
  payment = [],
  guaranteeLastParagraph = "",
  paymentLastParagraph = "",
  policyEndParagraph = "",
}) => ({
  title,
  subtitle: subTitle,
  policytitle: policyTitle,
  policies,
  guaranteetitle: guaranteeTitle,
  guaranteesubtitle: "",
  guarantee,
  guaranteeLastParagraph:
    guaranteeLastParagraph ||
    (note && noteDetails ? `<p><strong>${note}</strong> ${noteDetails}</p>` : ""),
  paymenttitle: paymentTitle,
  payment,
  paymentLastParagraph,
  policyEndParagraph,
});

const PROGRAM_POLICIES = [
  {
    title: "Leadership Essentials Program",
    cancellationPolicy: mapLegacyPolicy({
      title: "Iron Lady Leadership Program – Cancellation/Reschedule Policy",
      subTitle:
        "After availing a seat in the program, the participants are encouraged to undertake the program for the batch for which the seat is offered.",
      policyTitle:
        "In the event of unforeseen situations, the below policy of refund and reschedule will apply",
      policies: [
        {
          id: 1,
          value:
            "Seats for our programs are offered based on the batch selection done by you within two days of registration.",
        },
        {
          id: 2,
          value:
            "A seat offered for a batch cannot be carried forward to another batch or for another person.",
        },
        {
          id: 3,
          value:
            "For some unforeseen reasons, if the participant has to reschedule the batch the same can be done by paying a one-time rescheduling charge of INR 500. Rescheduling the program more than once is not allowed.",
        },
        {
          id: 4,
          value:
            "Initial Registration Fee (2,999/-) is non-refundable before starting the batch. (Refer quality guarantee for refund clauses after starting the batch)",
        },
        {
          id: 5,
          value:
            "Participants who are terminated for not adhering to the basic guidelines of the program or lack of participation or such will not get any refund",
        },
        {
          id: 6,
          value:
            "Any participant who discontinues the program on their own accord will not get any refund",
        },
      ],
      guaranteeTitle: "Our Quality Guarantee:",
      guarantee: [
        {
          id: 1,
          value:
            "Once a participant completes 4 weeks of the program (before certification), if the participant is not satisfied and wishes to avail a refund for not being happy with the program, she is eligible to get even 100% of the refund including registration amount, if she had implemented all the principles/actions/rituals suggested to her during the program.",
        },
        {
          id: 2,
          value:
            "She can seek a refund by sending an official email to accounts@iamironlady.com along with her progress so far, actions taken and clear reasons for escalation.",
        },
        {
          id: 3,
          value:
            "The refund amount will be decided based on the involvement of the participant in the program, progress so far and reasons for escalation.",
        },
        {
          id: 4,
          value:
            "If the participant doesn't complete the 4 weeks of the program, no part of the fees paid will be refunded.",
        },
      ],
      note: "Note:",
      noteDetails: "Part payments / EMI payment options will not be eligible for any refund.",
    }),
    programFee: {
      cancellation: "Cancellation/Reschedule Policy",
    },
  },
  {
    title: "100 Board Members Program",
    cancellationPolicy: mapLegacyPolicy({
      title: "Iron Lady 100 BM Program – Cancellation/Reschedule Policy",
      guaranteeTitle: "Our Quality Guarantee:",
      guarantee: [
        {
          id: 1,
          value:
            "Once a participant completes 6 months of the program (before certification), if the participant is not satisfied and wishes to avail a refund for not being happy with the program, she is eligible to get even 100% of the refund including registration amount based on actions taken and progress so far, if she has implemented all the principles/actions/rituals suggested to her during the program.",
        },
        {
          id: 2,
          value:
            "She can seek a refund by sending an official email to accounts@iamironlady.com along with her progress so far, actions taken and clear reasons for escalation.",
        },
        {
          id: 3,
          value:
            "The refund amount will be decided based on the involvement of the participant in the program, progress so far and reasons for escalation.",
        },
        {
          id: 4,
          value:
            "If the participant doesn't complete the 6 months of the program, no part of the fees paid will be refunded.",
        },
      ],
      note: "Note:",
      noteDetails: "Part payments / EMI payment options will not be eligible for any refund.",
    }),
    programFee: {
      cancellation: "Cancellation/Reschedule Policy",
    },
  },
  {
    title: "Master of Business Warfare Program",
    cancellationPolicy: mapLegacyPolicy({
      title: "Iron Lady Leadership Program – Cancellation/Reschedule Policy",
      subTitle:
        "Program registration can be cancelled 15 days before the program begins. Post that cancellation is not possible and no part of the fees paid will be refunded. Fixed component of the complete payment needs to be done before the program begins. Variable pay needs to be paid based on the progress achieved for the goals set on mutual agreement",
      guaranteeTitle: "Our Quality Guarantee:",
      guarantee: [
        {
          id: 1,
          value:
            "Once a participant completes 4 weeks of the program (before certification), if the participant is not satisfied and wishes to avail a refund for not being happy with the program, she is eligible to get even 100% of the refund including registration amount, if she had implemented all the principles/actions/rituals suggested to her during the program.",
        },
        {
          id: 2,
          value:
            "She can seek a refund by sending an official email to accounts@iamironlady.com along with her progress so far, actions taken and clear reasons for escalation.",
        },
        {
          id: 3,
          value:
            "The refund amount will be decided based on the involvement of the participant in the program, progress so far and reasons for escalation.",
        },
        {
          id: 4,
          value:
            "If the participant doesn't complete the 4 weeks of the program, no part of the fees paid will be refunded.",
        },
      ],
      note: "Note:",
      noteDetails: "Part payments / EMI payment options will not be eligible for any refund.",
    }),
    programFee: {
      cancellation: "Cancellation/Reschedule Policy",
    },
  },
];

const normalizeProgramSlug = (value = "") =>
  decodeURIComponent(value).split(" ").join("_").toLowerCase();

export const findProgramPolicyBySlug = (programSlug) => {
  const normalizedSlug = normalizeProgramSlug(programSlug);

  return PROGRAM_POLICIES.find(
    (program) => normalizeProgramSlug(program.title) === normalizedSlug
  ) ||
    (normalizedSlug.includes("master_of_business_warfare")
      ? PROGRAM_POLICIES.find((program) =>
          program.title.toLowerCase().includes("master of business warfare")
        )
      : null);
};

export const getProgramPolicyFallbackResponse = () => ({
  data: {
    data: {
      individual_program: PROGRAM_POLICIES,
      individual_program_hindi: [],
    },
  },
});
